import type { ReactNode } from "react";
import type { PageContext } from "vike/types";
import { VariantProvider } from "../src/hooks/useVariant";
import { PageContextProvider } from "../src/hooks/usePageContext";
import OidcAuthProvider from "../src/components/auth/OidcAuthProvider";
import "../src/styles/global.css";

export function PageShell({
  children,
  pageContext,
}: {
  children: ReactNode;
  pageContext: PageContext;
}) {
  const initialVariant = pageContext.variantFromCookie ?? "editorial";
  return (
    <PageContextProvider pageContext={pageContext}>
      <VariantProvider initialVariant={initialVariant}>
        {/* Sub-Step 3.3 — OidcAuthProvider wrapt alle Pages mit
            react-oidc-context. SSR-safe via ClientOnly-Boundary:
            während Server-Render werden children direkt gerendert
            (kein Provider, kein Crash). Nach Hydration mountet der
            echte AuthProvider + AutoSilentSso. */}
        <OidcAuthProvider>{children}</OidcAuthProvider>
      </VariantProvider>
    </PageContextProvider>
  );
}
